import { Inject, Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { filter, take, timeout, catchError } from 'rxjs/operators';
import { animate, AnimationBuilder, style } from '@angular/animations';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SplashScreenService {

  splashScreenElem: HTMLElement;
  private hideTimeout: any;

  constructor(private router: Router,
              @Inject(DOCUMENT) private document: Document,
              private animationBuilder: AnimationBuilder) {
    this.splashScreenElem = this.document.body.querySelector('#vex-splash-screen');

    if (this.splashScreenElem) {
      // Intentar ocultar cuando ocurre NavigationEnd
      this.router.events.pipe(
        filter(event => event instanceof NavigationEnd),
        take(1),
        timeout(5000), // Timeout de 5 segundos
        catchError(() => {
          // Si no hay NavigationEnd en 5 segundos, ocultar de todas formas
          this.hide();
          return of(null);
        })
      ).subscribe(() => this.hide());

      // Fallback: ocultar después de 3 segundos si no se ha ocultado antes
      this.hideTimeout = setTimeout(() => {
        if (this.splashScreenElem && this.splashScreenElem.parentNode) {
          this.hide();
        }
      }, 3000);
    }
  }

  hide() {
    if (!this.splashScreenElem || !this.splashScreenElem.parentNode) {
      return;
    }

    // Limpiar timeout si existe
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
      this.hideTimeout = null;
    }

    try {
      const player = this.animationBuilder.build([
        style({
          opacity: 1
        }),
        animate('400ms cubic-bezier(0.25, 0.8, 0.25, 1)', style({
          opacity: 0
        }))
      ]).create(this.splashScreenElem);

      player.onDone(() => {
        if (this.splashScreenElem && this.splashScreenElem.parentNode) {
          this.splashScreenElem.remove();
        }
      });
      player.play();
    } catch (error) {
      // Si falla la animación, ocultar directamente
      if (this.splashScreenElem && this.splashScreenElem.parentNode) {
        this.splashScreenElem.style.display = 'none';
        this.splashScreenElem.remove();
      }
    }
  }
}
